import { PipeTransform, Pipe } from '@angular/core';
@Pipe({
    name: 'filterStatus'
})
export class FilterStatusPipe implements PipeTransform {
    transform(value, reason) {
        if (value) {
            if (reason === 'AptVacantPrevReg') {
                return value.filter(item => item.code !== 'Vacant');
            } else {
                return value;
            }
        }
    }
}
